<script>
export default {
  name: 'InjectEditorPracticeJs',
  methods: {
    loadJs() {
      const that = this
      const jsDir = 'js'
      const aceDistDir = jsDir + '/ace-build/src'
      const acejs = aceDistDir + '/ace.js'
      const aceThemeJs = aceDistDir + '/theme-cobalt.js'
      const acePythonModeJs = aceDistDir + '/mode-python.js'
      const aceCppModeJs = aceDistDir + '/mode-c_cpp.js'
      const aceJavaModeJs = aceDistDir + '/mode-java.js'
      const acePascalModeJs = aceDistDir + '/mode-pascal.js'
      const aceExtLanguageToolsJs = aceDistDir + '/ext-language_tools.js'
      this.$loadScript(acejs).then(() => {
        //   return that.$loadScript(that.$g.URL.jqconsole)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.editormdMinJs)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.JsCppMin)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.skulptMin)
        // }).then(() => {
        //   return that.$loadScript(that.$g.URL.skulptStdlib)
        // }).then(() => {
        //   return that.$loadScript(that.acejs)
      }).then(() => {
        return that.$loadScript(aceThemeJs)
      }).then(() => {
        return that.$loadScript(acePythonModeJs)
      }).then(() => {
        return that.$loadScript(aceCppModeJs)
      }).then(() => {
        return that.$loadScript(aceJavaModeJs)
      }).then(() => {
        return that.$loadScript(acePascalModeJs)
      }).then(() => {
        return that.$loadScript(aceExtLanguageToolsJs)
      }).then(() => {
        this.$emit('injectJSFinish', true)
      }).catch((err) => {
        // Failed to fetch script
        console.log(err)
      })
    }
  },
  render: function(createElement) {
    const that = this
    that.loadJs()
    return createElement('div', [])
  }
}
</script>
